export { default as RouteWithAnalytics } from './src/routes-with-analytics';
